import * as consts from '../Helpers/AppConstants';
import * as utils from '../Helpers/Utils';
import { EncryptStorage } from 'encrypt-storage';


export const encryptStorage = new EncryptStorage('secret-key-value', {
    storageType: 'sessionStorage',
  });

export const IsAlreadyLoggedin = () => {
    return !utils.isObjectUndefined(sessionStorage.getItem(consts.USER_AUTH_TOKEN));
}

export const GetLoggedInUserToken = ()=> {
    if(IsAlreadyLoggedin())
        return sessionStorage.getItem(consts.USER_AUTH_TOKEN);
    return '';
}

export const SetUserToken = (token:string)=>{
    sessionStorage.setItem(consts.USER_AUTH_TOKEN,token);
}


export const SetIDRole=(data:any)=>{
    const value = encryptStorage.encryptString(data[0].EmployeeOfficeBadgeId);
    sessionStorage.setItem(consts.USER_LOGINID,value)
    const value1 = encryptStorage.encryptString(data[0].Check_designation);
    sessionStorage.setItem(consts.USER_ROLE,value1)
    const value2 = encryptStorage.encryptString(data[0].FullName);
    sessionStorage.setItem(consts.USERNAME,value2)
    const value3 = encryptStorage.encryptString(data[0].ProductionRole);
    sessionStorage.setItem(consts.USER_Production_Role,value3)
    const department=(data[0].Department);
    sessionStorage.setItem(consts.Department,department);
    const FusionEmail=(data[0].EmployeeEmail);
    sessionStorage.setItem(consts.fusionAuthUserEmailToken,FusionEmail);
}

export const GetUserName=()=>{
    const val= sessionStorage.getItem(consts.USERNAME)|| '{}'

    return encryptStorage.decryptString(val);
}
export const GetUserLoginID=()=>{
   const val=sessionStorage.getItem(consts.USER_LOGINID)|| '{}'
    return encryptStorage.decryptString(val);
}

export const GetUserRole=()=>{
    const val=sessionStorage.getItem(consts.USER_ROLE)|| '{}'
    return encryptStorage.decryptString(val);
}

export const GetUserProductionRole=()=>{
    const val=sessionStorage.getItem(consts.USER_Production_Role)|| '{}'
    return encryptStorage.decryptString(val);
}

export const GetUserDepartment=()=>{
    const val=sessionStorage.getItem(consts.Department)|| '{}'
    return encryptStorage.decryptString(val);
}

export const SetFusionAuthToken = (token:string)=>{
    sessionStorage.setItem(consts.fusionAuthUserAccessToken,token);
}


export const GetFusionAuthAccessToken = () => {
    const val = sessionStorage.getItem(consts.fusionAuthUserAccessToken);
    return val || ''; 
}
